import React, { useContext } from 'react'

import { useApiRequest } from '../../hooks'
import UserDetails from '../UserDetails'
import { ApiContext } from '../../hooks/api';

export default function () {
  // const [user] = useApiRequest('admin/profile')
  const { user } = useContext(ApiContext);
  const [profile] = useApiRequest(`users/${user?.id}`);

  // return <div>{user && <UserDetails id={user.id} />}</div>
  return <div>{profile && <UserDetails id={profile.id} />}</div>;
}
